export const ROLES_AND_RESPONSIBILITIES_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Roles and Responsibilities",
        subtitle: "EXHIBIT A"
    },

    // Introduction
    {
        id: 1,
        type: 'introduction',
        text: "It is understood that the role and responsibilities of Contractor and Agency pursuant to this Agreement will be carried out as specified below in the following areas:"
    },

    // Section A: Orientation
    {
        id: 2,
        type: 'section',
        title: "A. Orientation",
        items: [
            {
                number: 1,
                responsible: "Agency",
                text: "Agency is responsible for providing trained professionals with information specific to the Agency's practices, including forms, policies, programs, and office procedures."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is responsible for ensuring its own knowledge of professional standards, Medicare and Medical regulations related to reimbursement, and JCAHO standards."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is responsible for arranging for orientation information to be completed and documented by the Agency."
            }
        ]
    },

    // Section B: Coordination of Care
    {
        id: 3,
        type: 'section',
        title: "B. Coordination of Care",
        items: [
            {
                number: 1,
                responsible: "Agency",
                text: "Agency is responsible for assigning patients to the Contractor."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is responsible for obtaining authorization for patient visits from the Agency."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is required to submit their weekly patient schedule to the Agency."
            },
            {
                number: 4,
                responsible: "Contractor",
                text: "Contractor is responsible for notifying the Agency within 24 hours if a patient is placed on hold."
            },
            {
                number: 5,
                responsible: "Agency",
                text: "Agency is responsible for notifying the Contractor within 24 hours if a patient is placed on hold."
            },
            {
                number: 6,
                responsible: "Contractor",
                text: "Contractor is responsible for coordinating Contract Services with other parties involved in the patient's care, including but not limited to:",
                subItems: [
                    "Initiating and updating the patient's Plan of Care.",
                    "Submitting the visit schedule to the Agency.",
                    "Notifying the Agency of external organizations or individuals involved in the patient's care."
                ]
            },
            {
                number: 7,
                responsible: "Contractor",
                text: "Contractor is responsible for consulting with the patient, family, caregivers, physician, and other staff involved in the patient's care as required by the patient's condition and as requested by the Agency."
            },
            {
                number: 8,
                responsible: "Contractor",
                text: "Contractor is responsible for reporting to the physician and Agency any situations requiring intervention, including but not limited to:",
                subItems: [
                    "The patient's reaction to treatment.",
                    "Changes in the patient's condition.",
                    "Abuse or neglect of the patient.",
                    "An unsafe patient environment.",
                    "New problems identified by the Contractor.",
                    "Lack of patient progress.",
                    "Patient injuries or complications."
                ]
            },
            {
                number: 9,
                responsible: "Contractor",
                text: "Contractor is responsible for reporting to the Agency any patient complaints regarding services provided by either the Contractor or the Agency."
            }
        ]
    },

    // Section C: Home Health Aide Assignment and Supervision
    {
        id: 4,
        type: 'section',
        title: "C. Home Health Aide Assignment and Supervision",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "When the Contractor is the initial discipline to see the patient, the Contractor is responsible for assessing the patient's need for other Agency services."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "If Contractor is providing Physical Therapy services to the patient, Contractor is responsible for completion of an Agency assignment sheet and providing and documenting supervision of AGENCY'S Home Health Aide(s) once every two weeks when nursing is not providing service to the patient."
            }
        ]
    },

    // Section D: Scheduling of Visits
    {
        id: 5,
        type: 'section',
        title: "D. Scheduling of Visits",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is responsible for scheduling visits with the patient and notifying the patient when the date or time of the visit is changed."
            },
            {
                number: 2,
                responsible: "Agency",
                text: "Agency is responsible for notifying Contractor within one hour when patient cancels an appointment."
            }
        ]
    },

    // Section E: Patient Care Conference
    {
        id: 6,
        type: 'section',
        title: "E. Patient Care Conference",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is required to participate in Patient Care Conference when providing ongoing service to patients. Contractor is required to notify Agency if unable to attend the Patient Care Conference. If Contractor is unable to attend interdisciplinary team conference two options exist:",
                subItems: [
                    "a. arrange to be available to interdisciplinary team conference by phone at the regularly scheduled meeting time or,",
                    "b. provide a verbal or written report on current patients in advance of the regularly scheduled meeting which provides a summary of the patients progress and as needed, recommendations to the interdisciplinary team related to the patients care."
                ]
            },
            {
                number: 2,
                responsible: "Agency",
                text: "Agency is responsible for notifying Contractor when the date or time of the Patient Care Conference changes."
            },
            {
                number: 3,
                responsible: "Agency",
                text: "Agency is responsible for compensating Contractor for attendance at Patient Care Conference."
            }
        ]
    },

    // Section F: Patient Admission
    {
        id: 7,
        type: 'section',
        title: "F. Patient Admission",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is responsible for assessing patients for appropriateness of admission to service in the appropriate discipline in accordance with Agency admission criteria."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Patients will not be admitted to the Contractor's private practice without prior written approval of the Agency."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is responsible for notifying Agency of evaluation findings, recommendation(s) regarding the appropriateness of admission and the need for further visits within twenty-four (24) hours of the initial evaluation/assessment visit. Agency will determine if patient should be admitted based on the information provided by Contractor and other sources."
            },
            {
                number: 4,
                responsible: "Contractor",
                text: "When Contractor is initial discipline seeing the patient, Contractor is responsible for providing Agency Start of Care packet to the patient and filling out the necessary case opening paperwork."
            },
            {
                number: 5,
                responsible: "Contractor",
                text: "Contractor is to perform an initial evaluation/assessment visit the next working day after referral acceptance, unless other arrangements are made with the Agency."
            }
        ]
    },

    // Section G: Patient Assessment
    {
        id: 8,
        type: 'section',
        title: "G. Patient Assessment",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor will perform a thorough assessment in accordance with standards of practice for their specialty which may include, but not be limited to:",
                subItems: [
                    "a. patient's physical, psychosocial, coping and mental status;",
                    "b. home environment, home safety, and patient's living arrangements;",
                    "c. patient's level of function, limitations, activity restrictions, and ability to perform ADL's;",
                    "d. availability and competence of caregivers;",
                    "e. equipment needs of patient;",
                    "f. patient's communication ability and ability to learn;",
                    "g. patient's needs and problems based on the assessment performed, including need for other Agency services."
                ]
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is to perform an initial evaluation/assessment visit the next working day after referral acceptance, unless other arrangements are made with the Agency."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is to perform and document ongoing patient assessment at each visit, which may include, but is not limited to:",
                subItems: [
                    "a. patient's physical, psychosocial, coping, and mental status;",
                    "b. patient's progress towards goals;",
                    "c. status of problems previously identified;",
                    "d. patient's response to treatment;",
                    "e. changes in the patient's condition; and",
                    "f. new problems or needs."
                ]
            }
        ]
    },

    // Section H: Plan of Care (POC) and Plan of Treatment (POT)
    {
        id: 9,
        type: 'section',
        title: "H. Plan of Care (POC) and Plan of Treatment (POT)",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is responsible for developing and submitting an individualized Plan of Care (POC) to the Agency within two (2) days of the initial visit, in coordination with physician orders. The POC is to include:",
                subItems: [
                    "a. problems and needs of the patient based on the assessment performed;",
                    "c. frequency and duration of interventions; and",
                    "d. reasonable and measurable goals with a statement of expectation over a defined period of time."
                ]
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is expected to develop and revise the Plan of Care, including goals, with the participation of the patient."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is expected to review the Plan of Care at each visit and recommend any additions or revisions needed to the Agency."
            },
            {
                number: 4,
                responsible: "Contractor",
                text: "Contractor is to revise the Plan of Care with the approval of the patient's physician as may be required by changes in the patient's condition, lack of progress, or when new problems are identified."
            },
            {
                number: 5,
                responsible: "Contractor",
                text: "Contractor is responsible for notifying the Agency within 48 hours when the Plan of Care is revised."
            },
            {
                number: 6,
                responsible: "Contractor",
                text: "Contractor is responsible for submitting to the Agency information required for the development of an individualized Plan of Treatment (POT) for each patient, in accordance with physician orders, within two (2) days of the initial visit and every sixty (60) days thereafter. The POT should include, but is not limited to:",
                subItems: [
                    "a. patient's prognosis and rehabilitation potential;",
                    "b. patient's primary and secondary diagnoses with onset dates;",
                    "c. specific treatments or interventions;",
                    "d. patient and caregiver teaching;",
                    "e. frequency and duration of services in accordance with physician orders;",
                    "f. patient's condition; and",
                    "g. applicable regulations and authorizations of patient's payer source."
                ]
            },
            {
                number: 7,
                responsible: "Agency",
                text: "Agency is responsible for submitting the POT to the patient's physician for signature and assuring that the POT is returned to the patient's file with the physician's signature."
            },
            {
                number: 8,
                responsible: "Contractor",
                text: "Contractor is responsible for contacting the physician when care necessitates a physician's order and involving the physician in the development and review of the POC and POT."
            },
            {
                number: 9,
                responsible: "Contractor",
                text: "No alteration of scope or limitation of service detailed in the POC or POT can be made by the Contractor without the approval of the Agency."
            }
        ]
    },

    // Section I: Discharge Planning and Patient Discharge
    {
        id: 10,
        type: 'section',
        title: "I. Discharge Planning and Patient Discharge",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is responsible for providing the patient with ongoing discharge planning and documenting the discharge planning on progress note(s) or other appropriate form(s) in accordance with Agency policy."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is responsible for assessing patients for discharge in accordance with Agency discharge criteria."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is responsible for providing and documenting discharge instructions to the patient and caregiver including, but not limited to, any continuing care needs and how patient can obtain such care."
            },
            {
                number: 4,
                responsible: "Contractor",
                text: "Contractor is to notify Agency of the patient's discharge the day of the discharge visit or the next working day if visit is made late in the day."
            },
            {
                number: 5,
                responsible: "Contractor",
                text: "Contractor is to complete a Discharge Summary at time of discharge on all patients which includes, but is not limited to:",
                subItems: [
                    "a. documentation of the patient's physical, psychosocial, and mental status;",
                    "b. status of initial and subsequent problems;",
                    "c. summary of care provided;",
                    "d. date and reason for discharge; and",
                    "e. if goals were met or identifying any reason goals were not met."
                ]
            },
            {
                number: 6,
                responsible: "Contractor",
                text: "Contractor is responsible for notifying the patient, caregivers, and physician of patient's discharge."
            }
        ]
    },

    // Section J: Documentation Requirements/Submission of Paperwork
    {
        id: 11,
        type: 'section',
        title: "J. Documentation Requirements/Submission of Paperwork",
        items: [
            {
                number: 1,
                responsible: "Contractor",
                text: "Contractor is to complete evaluation paperwork the day of the visit and submit it to Agency within two (2) days of initial visit."
            },
            {
                number: 2,
                responsible: "Contractor",
                text: "Contractor is to complete a progress note for each visit made. A progress note consists of a dated written record that includes, but is not limited to, observations, assessments, interventions, and plans for each visit or contact made."
            },
            {
                number: 3,
                responsible: "Contractor",
                text: "Contractor is to complete all progress notes on the day of the visit and submit them to Agency within five (5) days of the visit."
            },
            {
                number: 4,
                responsible: "Contractor",
                text: "Contractor is to complete and submit to Agency a Discharge Summary for each patient discharged within five (5) days of the discharge visit."
            },
            {
                number: 5,
                responsible: "Contractor",
                text: "Contractor is to document all contact with attending physician(s) including, but not limited to, reason for contact, recommendations to physician, and outcome of contact."
            },
            {
                number: 6,
                responsible: "Contractor",
                text: "Supplemental physician orders are to be completed the day the order is received and submitted to Agency within five (5) days of completion. If the order involves coordination of care or intervention with other staff, Contractor is required to contact Agency the day the order is made."
            },
            {
                number: 7,
                responsible: "Contractor",
                text: "Contractor may mail original paperwork or deliver it to agency."
            },
            {
                number: 8,
                responsible: "Contractor",
                text: "Contractor must submit paperwork to Agency for the last week of each month by the second (2nd) working day of the next month."
            },
            {
                number: 9,
                responsible: "Contractor",
                text: "Contractor is responsible for completing all documentation in accordance with standards of practice for that specialty and type of service as well as all-applicable state and federal regulations, JCAHO standards and Agency policies."
            },
            {
                number: 10,
                responsible: "Contractor",
                text: "Contractor is responsible for completing and correcting medical records for Contact Services provided."
            },
            {
                number: 11,
                responsible: "Agency",
                text: "Agency is responsible for providing a sufficient quantity of Agency forms prior to patient treatment for Contractor to properly meet time and documentation requirements."
            }
        ]
    },

    // Section K: Evaluation of Contractor Performance
    {
        id: 12,
        type: 'section',
        title: "K. Evaluation of Contractor Performance",
        items: [
            {
                number: 1,
                responsible: "Agency",
                text: "Agency is responsible for providing information to Contractor regarding Agency policy or standards changes. Contractor is responsible for reviewing such information and incorporating it into patient care, documentation practices and other applicable duties."
            },
            {
                number: 2,
                responsible: "Agency",
                text: "Agency is responsible for an annual review of the performance of Contractor including, but not limited to, review of whether:",
                subItems: [
                    "a. Quality and timeliness of documentation has been in accordance with standards of practice for that specialty and type of service as well as all applicable state and federal regulations, JCAHO standards and Agency policies;",
                    "b. Quality of patient assessment and treatment provided is satisfactory;",
                    "c. Care has been provided in accordance with Plan of Treatment and Plan of Care",
                    "d. Care has been coordinated and Agency has been contacted as required;",
                    "e. Contractor's personnel are in compliance with and have provided adequate documentation for current personnel qualifications including, but not limited to professional licensure, CPR certification, medical history, negative TB test, satisfactory medical examination, hepatitis statement, drivers license, automobile insurance, liability insurance for independent contractors of Contractor, and resume;",
                    "f. Contractor has participated as needed in Patient Care Conferences; and",
                    "g. Other applicable terms of the Contractor's Health Services Agreement have been consistently adhered to."
                ]
            }
        ]
    },

    // EXHIBIT B: Supervision of PTA or COTA
    {
        id: 13,
        type: 'exhibit',
        title: "EXHIBIT B",
        subtitle: "SUPERVISION OF PTA OR COTA",
        items: [
            {
                number: 1,
                text: "Contractor may employ a Physical Therapist Assistant (PTA) or Occupational Therapy Assistant (COTA) to extend the services of a Physical Therapist or Occupational Therapist and fulfill all Physical/Occupational Therapy functions as allowed by state and federal law. Contractor is responsible for the therapeutic supervision of their PTA or COTA employees, which must adhere to guidelines from the Physical Therapy Examining Committee of California or the American Occupational Therapy Association. Additionally, supervision must comply with home health regulations under Title 22, federal law, and the Joint Commission standards for home care accreditation. Contractor is required to maintain all relevant documentation demonstrating compliance with these supervision regulations and must provide this evidence to the Agency upon demand."
            },
            {
                number: 2,
                text: "As an independent contractor/employer, the contractor is bound by the provisions set forth in the \"Contractor Agreement,\" specifically the section titled \"Status as Independent Contractor,\" as it relates to the Contractor's employees."
            }
        ]
    },

    // Signature
    {
        id: 14,
        type: 'signature',
        title: "Initial",
        fields: [
            { label: "Initial", name: "initial" }
        ]
    }
];